import GroupedReportView from '../../../components/reports/GroupedReportView';

export function StatementOfChangesReport() {
  return (
    <GroupedReportView
      title="Statement of Changes in Fund Balance"
      description="Movement in the fund balance over a period: opening balance plus net surplus/deficit equals closing balance."
      endpoint="/reports/consolidated/statement-of-changes"
      filters={['dateRange']}
      supportsComparative
      xlsx
    />
  );
}
